import React from "react";
import {
  Root,
  Wrapper,
  Header,
  HeaderLeft,
  HeaderRight,
  MessagesList,
  MessageRow,
  MessageBubble,
  InputBar,
} from "./ChatSkeleton.styled";
import { Skeleton } from "@ann/web-components";

const MESSAGES = [
  { isUser: false, lines: ["60%", "80%"] },
  { isUser: true, lines: ["70%", "50%"] },
  { isUser: false, lines: ["65%", "75%", "40%"] },
  { isUser: true, lines: ["55%"] },
  { isUser: false, lines: ["70%", "60%"] },
];

const ChatSkeleton = ({ show = false }) => {
  if (!show) return null;

  return (
    <Root>
      <Wrapper>
        <Header>
          <HeaderLeft>
            <Skeleton height="20px" width="120px" borderRadius="10px" />
          </HeaderLeft>
          <HeaderRight>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} height="24px" width="24px" borderRadius="12px" />
            ))}
          </HeaderRight>
        </Header>

        <MessagesList>
          {MESSAGES.map((msg, idx) => (
            <MessageRow key={idx} $isUser={msg.isUser}>
              <MessageBubble>
                {msg.lines.map((w, i) => (
                  <Skeleton key={i} height="16px" width={w} />
                ))}
              </MessageBubble>
            </MessageRow>
          ))}
        </MessagesList>

        <InputBar>
          <Skeleton height="80px" width="100%" borderRadius="8px" />
        </InputBar>
      </Wrapper>
    </Root>
  );
};

export default ChatSkeleton;
